import { Component, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import {Router} from '@angular/router';
import { MatDialogRef, MatDialog } from '@angular/material';
import { CookieService } from 'ngx-cookie';

@Injectable()
export class RequestsHandler {

    constructor(private _http: HttpClient,
                private router: Router,
                public dialog: MatDialog,
                private _cookieService: CookieService) { }

    headers() {
      const authToken =  this._cookieService.get('auth_token');
      let headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      });
      if (authToken) {
        headers = headers.append('Authorization', `Bearer ${authToken}`);
      }
      return headers;
    }

    handleError (error) {
      if (!error.status) {
        return;
      }
      switch (error.status) {
        case 500: this.openMessageDialog('warn', 'Error! ' + error.statusText, error.error.hasOwnProperty('message') ? error.error.message : error.message); break;
        case 422: this.openMessageDialog('warn', 'Error! ' + error.statusText, JSON.stringify(error.error)); break;
        // case 401: console.log('401'); this.router.navigate(['/logout']); break;
        case 403: this.openMessageDialog('warn', 'Error! ' + error.statusText, JSON.stringify(error.error)); break;
        case 404: this.openMessageDialog('warn', 'Error! ' + error.statusText, JSON.stringify(error.error)); break;
        default : let title = '';
                  let text = '';
                  const errorBody = JSON.parse(error._body);
                  if (errorBody.error) {
                    title = 'Error! ' + error.statusText;
                    text = errorBody.error;
                  } else {
                    title = 'Error!';
                    text = error.statusText;
                  }
                  this.openMessageDialog('warn', title, text);
              }
    }

    openMessageDialog(type, title, text) {
        const dialogRef = this.dialog.open(MessageDialog, {width: '400px'});
        dialogRef.componentInstance.type = type;
        dialogRef.componentInstance.title = title;
        dialogRef.componentInstance.text = text;
    }

}


@Component({
    selector: 'message-dialog',
    template: `
        <div class='modal-content'>
            <div class='modal-title bg-{{type}}'>
                <h3>{{title}}</h3>
            </div>
            <div class='modal-body'>
                {{text}}
            </div>
            <mat-dialog-actions align='end'>
                <button mat-button class='right' (click)='closeModal()'>Ok</button>
            </mat-dialog-actions>
        </div>
    `,
})
export class MessageDialog {
    type = 'primary';
    title = 'Message';
    text = '';
    constructor(
        public dialogRef: MatDialogRef<MessageDialog>
    ) { }
  closeModal() {
    this.dialogRef.close('ok');
  }

}



// WEBPACK FOOTER //
// ./src/app/services/requests.service.ts